import { Button } from '../ui/button';
import { Cpu, Film, Image as ImageIcon } from 'lucide-react';
import { format } from 'date-fns';

export const GenerationsPanel = ({ project, onMedia, onModels }) => (
  <div className="bg-slate-50 border-l-4 border-indigo-300 px-6 py-4" data-testid={`generations-panel-${project.id}`}>
    <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
      Generations ({project.generation_count})
    </div>
    <div className="max-h-80 overflow-y-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-slate-500 border-b border-slate-200">
            <th className="py-2 pr-4 font-medium">#</th>
            <th className="py-2 pr-4 font-medium">Generation ID</th>
            <th className="py-2 pr-4 font-medium">Date</th>
            <th className="py-2 pr-4 font-medium">Media</th>
            <th className="py-2 pr-4 font-medium">Models</th>
          </tr>
        </thead>
        <tbody>
          {project.generations.map((g, i) => (
            <tr key={g.id} className="border-b border-slate-100" data-testid={`generation-row-${g.id}`}>
              <td className="py-2 pr-4 text-slate-400">{project.generation_count - i}</td>
              <td className="py-2 pr-4 font-mono text-xs text-slate-600 break-all">{g.id}</td>
              <td className="py-2 pr-4 text-slate-700">
                {g.created_at ? format(new Date(g.created_at), 'MMM dd, yyyy HH:mm') : '—'}
              </td>
              <td className="py-2 pr-4">
                <Button
                  variant="outline"
                  size="sm"
                  data-testid={`generation-media-${g.id}`}
                  disabled={!g.media_count}
                  onClick={() => onMedia({ id: g.id, project_name: `${project.project_name} · generation` })}
                >
                  {g.has_video ? <Film className="w-4 h-4 mr-1" /> : <ImageIcon className="w-4 h-4 mr-1" />}
                  {g.media_count ? `View (${g.media_count})` : 'None'}
                </Button>
              </td>
              <td className="py-2 pr-4">
                <Button variant="outline" size="sm" data-testid={`generation-models-${g.id}`} onClick={() => onModels(g.id)}>
                  <Cpu className="w-4 h-4 mr-1" /> Models
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
